/// <reference path="../../node_modules/@types/jquery.validation/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery-validation-unobtrusive/index.d.ts" />

if (typeof ($.validator) !== "undefined")
{
    $.validator.setDefaults({
        ignore: ""
    });

    const setValidationValues = (options: any, ruleName: string, value: any) =>
    {
        options.rules[ruleName] = value;
        if (options.message)
        {
            options.messages[ruleName] = options.message;
        }
    };

    $.validator.unobtrusive.adapters.add("mustbetrue",
        (options: any) =>
        {
            setValidationValues(options, "mustbetrue", true);
        });

    $.validator.addMethod("mustbetrue",
        function(this: any, _, element, param)
        {
            if (!this.depend(param, element))
            {
                return false;
            }

            return (element as HTMLInputElement).checked;
        });
}

$(() =>
{
    $("#product-downloads-btn")
        .click(ev =>
        {
            ev.preventDefault();
            $("#product-downloads").toggleClass("show");
        });

    $("#page-navigation-collapse li, #footer-menu li").on("show.bs.dropdown", (ev) =>
    {
        $(ev.currentTarget).parentsUntil("#page-navigation-collapse").each((_, elem) =>
        {
            elem.classList.add("open");
        });
    })
});